import 'ui-core/plugins/controller/js/controller.js';
import 'core-js/es/array/from';
import 'core-js/es/array/find';

(function () {
    UX.controller.disable = function (e) {
        if (typeof UX[UX.controller.active].$controller !== 'undefined') {
            UX[UX.controller.active].$controller.focus();
        }
        UX[UX.controller.active]?.on.hide(e);
    };
    UX.controller.extra = function () {
        UX.controller.$body.on('click focusout', function (e) {
            // hide / close opened components when click out side it
            // @todo: this can be still improved for nested compoentns, when click is outside of all of them, close all, not only current one - but it is a feature
            // if key was pressed, than we need to operate with related target, not original target
            if (e.type === 'focusout' && e.target !== e.relatedTarget) {
                if (e.relatedTarget === null) {
                    e.target = e.relatedTarget;
                }
                // should do cleanup after fixing LIT-274766
                //there is a bug in focusout on IOS/Safari check https://stackoverflow.com/questions/20359962/jquery-mobile-focusout-event-for-relatedtarget-returns-incorrect-result-in-safar

                let allElemInList = document.querySelectorAll('*[id^="pane-federation-con"]');
                let selectedElem = Array.from(allElemInList).find(ele => ele === e.relatedTarget);
                if (
                    e.target === document.getElementById('main-content') &&
                    (e.relatedTarget === document.getElementById('pane-select-con') || e.relatedTarget === selectedElem)
                ) {
                    e.target = e.relatedTarget;
                }
            }
            UX.controller.active = UX.controller.$body.attr('data-active');
            UX.controller.$activeComponent =
                typeof UX[UX.controller.active] !== 'undefined' && !$(e.target).is('.sub-menu-item')
                    ? UX[UX.controller.active]
                    : 'undefined';

            if (
                typeof UX.controller.$activeComponent !== 'undefined' &&
                typeof UX.controller.$activeComponent.$section !== 'undefined' &&
                typeof UX.controller.$activeComponent.$controller !== 'undefined'
            ) {
                UX.controller.$container = UX.controller.$activeComponent.$section;
                UX.controller.$target = UX.controller.$activeComponent.$controller;
                UX.controller.checkToHide(e);
            }
        });
    };
})();
